import apiClient from "../../utils/apiClient"; // Adjust path based on your structure
const APIKEY = process.env.REACT_APP_INTERNAL_API_KEY




export const AddtoCart = (data) => {
  return apiClient.post(`/products/cart/items`, data, {
    headers: {
      "x-api-key": APIKEY,
    },
  });
};

export const getCartItems = (data) => {
  console.log("Fetching cart items with data:", data);
  return apiClient.get(`/products/cart`, {
    headers: {
      "x-api-key": APIKEY,
    },
  });
};

// Update cart item quantity
export const updateCartQuantity = (cartItemId, quantity, variantId = null) => {
  const data = {
    itemId: cartItemId,
    quantity,
    ...(variantId && { variantId }),
  };
  return apiClient.patch(`/products/cart/items/${cartItemId}`, data);
};

export const removeCartItem = (cartItemId, variantId = null) => {
  const params = variantId ? { variantId } : {};
  return apiClient.delete(`/products/cart/items/${cartItemId}`, { params });
};

export const ClearCart = (cartItemId, variantId = null) => {
  const params = variantId ? { variantId } : {};
  return apiClient.delete(`/products/cart`);
};

export const calculateCartTotal = (data) => {
  return apiClient.post(`/setups/schemes/calculate-with-schemes`, data, {
    headers: {
      "x-api-key": APIKEY,
    },
  });
};


export const DeliveryForZipcode = (postalCode) => {
  return apiClient.get(`/setups/zipcode/ZipCodeAvailability/${postalCode}`);
};


export const FetchAddress = (uuid) => {
  return apiClient.get(`/users/addresses?entityType=consumer&entityId=${uuid}`);
};

export const CreateAddress = (addressData) => {
  return apiClient.post(`/users/addresses`, addressData);
};

export const DefaultAddress = (address) => {
  return apiClient.patch(`/users/addresses/${address.id}/set-default`, { entityId: address.entityId, entityType: "consumer" });
};
export const EditAddress = (addressId, addressData) => {
  return apiClient.put(`/users/addresses/${addressId}`, addressData);
}
export const DeleteAddress = (addressId) => {
  return apiClient.patch(`/users/addresses/${addressId}/deactivate`);
};

